import { localizeNumberInput } from './numeric-input-utils';
export const formatPrice = (input, locale) => {
  const filteredInput = input.replace(',', '.').match(/[\d.]+/);
  if (!filteredInput) {
    return null;
  }
  const number = filteredInput[0];
  const decimalSeparator = number.indexOf('.');
  const decimal = decimalSeparator !== -1 && number.length > decimalSeparator + 2 ? number.substring(0, decimalSeparator + 3) : number;
  const localizedNumber = localizeNumberInput(decimal, locale);
  const normalizedValue = Number(localizedNumber.replace(/,/g, '.'));
  return isNaN(normalizedValue) ? null : localizedNumber;
};
export const getCurrencyAriaLabel = (t, currency) => currency != null && currency.code ? t(`locale-dataset.currencies.${currency == null ? void 0 : currency.code}`) : (currency == null ? void 0 : currency.sign) || '';
//# sourceMappingURL=payment-field-utils.js.map